// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__px2ss","panel":"styles_panel__wdaQC","buttons":"styles_buttons__IlrpA","button":"styles_button__7sJ0z"};